import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, ShoppingCart } from 'lucide-react';

const FitnessPackages = () => {
  const navigate = useNavigate();

  const handleCheckout = (product, price) => {
    navigate('/checkout', { 
      state: { 
        product: product,
        price: price
      }
    });
  };

  return (
    <div className="container py-8" data-testid="fitness-packages-page">
      {/* Back Button */}
      <button
        onClick={() => navigate('/fitness')}
        className="flex items-center gap-2 text-[#2C3E2D] hover:text-[#D97706] transition-colors mb-8"
        data-testid="back-button"
      >
        <ArrowRight className="w-5 h-5" />
        <span className="font-medium">חזרה למוצרים</span>
      </button>

      <div className="max-w-3xl mx-auto">
        {/* Title */}
        <h1 className="text-4xl md:text-5xl font-bold text-[#2C3E2D] text-center mb-8" style={{ fontFamily: 'Heebo, sans-serif' }} data-testid="packages-title">
          חבילות ומבצעים
        </h1>

        {/* Package Card */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border-4 border-[#D97706]">
          {/* Badge */}
          <div className="bg-[#D97706] text-white text-center py-3">
            <span className="text-xl font-bold" style={{ fontFamily: 'Heebo, sans-serif' }}>
              מבצע מיוחד!
            </span>
          </div>
          
          {/* Image */}
          <div className="p-6 bg-stone-50">
            <img
              src="https://customer-assets.emergentagent.com/job_intimate-care-pro-1/artifacts/sg9j9f08_%D7%9C%D7%97%D7%99%D7%96%D7%95%D7%A7%20%D7%95%D7%A9%D7%99%D7%A4%D7%95%D7%A8%20%D7%94%D7%90%D7%95%D7%9F%20%D7%94%D7%92%D7%91%D7%A8%D7%99%20%28701%20x%20700%20%D7%A4%D7%99%D7%A7%D7%A1%D7%9C%29%20%28850%20x%20700%20%D7%A4%D7%99%D7%A7%D7%A1%D7%9C%29%20%28700%20x%20700%20%D7%A4%D7%99%D7%A7%D7%A1%D7%9C%29%20%28700%20x%20700%20%D7%A4%D7%99%D7%A7%D7%A1%D7%9C%29%20%28700%20x%20700%20%D7%A4%D7%99%D7%A7%D7%A1%D7%9C%29.png"
              alt="חבילת לחיי לילה טובים יותר"
              className="w-full h-auto max-h-96 object-contain mx-auto"
              data-testid="package-image"
            />
          </div>

          {/* Title and Description */}
          <div className="px-6 py-4 text-center">
            <h2 className="text-2xl font-bold text-[#2C3E2D] mb-2" style={{ fontFamily: 'Heebo, sans-serif' }}>
              לחיי לילה טובים יותר
            </h2>
            <p className="text-stone-600">
              חבילה מושלמת הכוללת: Promescent + Back 2 Game + Titan Gel Gold
            </p>
          </div>

          {/* Price and Button */}
          <div className="p-6 bg-stone-50 text-center">
            <div className="text-4xl font-bold text-[#D97706] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
              899 ש"ח
            </div>
            <button
              onClick={() => handleCheckout('חבילת לחיי לילה טובים יותר - Promescent + Back 2 Game + Titan Gel Gold', 899)}
              className="w-full flex items-center justify-center gap-3 px-8 py-4 rounded-full bg-[#D97706] text-white font-bold text-xl hover:bg-[#B45309] hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300"
              style={{ fontFamily: 'Heebo, sans-serif' }}
              data-testid="package-checkout-button"
            >
              <ShoppingCart className="w-6 h-6" />
              מעבר לרכישה
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FitnessPackages;
